module.exports = __webpack_public_path__ + "img/西瓜10.ae54428f.png";